import React from 'react';
import PropTypes from 'prop-types';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const { errorMessage, onError } = this.props;
    // eslint-disable-next-line no-console
    console.error(errorMessage);

    if (onError) {
      onError(error, errorInfo);
    }
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return null;
    }
    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  errorMessage: PropTypes.string,
  onError: PropTypes.func,
};

ErrorBoundary.defaultProps = {
  errorMessage: 'ERROR: Something went wrong',
  onError: undefined,
};

export default ErrorBoundary;
